import TaskListFilterableDemo from "../../components/feature-items/taskList/TaskListFilterableDemo";
import ContentWrapper from "../../pageStructures/contentWrapper/ContentWrapper";

function TestHome() {
  return (
    <ContentWrapper classes="bg__noise_daexgreen">
      <TaskListFilterableDemo></TaskListFilterableDemo>{" "}
    </ContentWrapper>
  );
}

export default TestHome;
